<script>
  import Sign from "./Components/sign.svelte"

  export let currentpage

  export let users

  export let pdfDimensions = {}

  export let loadingPDF = false

  let enableDrag = false

  let currentCoordinate = ""

  /**
   * @type {HTMLDivElement}
   */
  let draggedElem

  let activePlacement

  /**
   * Adjusts the position of the signature image element based on mouse movements over the position overlay.
   *
   * @param {MouseEvent} e - The mouse event object containing information about the mouse position.
   */
  const positionOverlayMouseCapture = (e) => {
    if (!enableDrag || !draggedElem) return

    let positionOverlay = draggedElem.parentElement
    if (!positionOverlay) return

    let childElemWidth = parseFloat(getComputedStyle(draggedElem).width)
    let childElemHeight = parseFloat(getComputedStyle(draggedElem).height)

    let offsetX = e.clientX - positionOverlay.getBoundingClientRect().left
    let offsetY = e.clientY - positionOverlay.getBoundingClientRect().top

    // Calculate the ratio of the actual document size to the displayed overlay size
    let yRatio = pdfDimensions.height / pdfDimensions.clientHeight
    let xRatio = pdfDimensions.width / pdfDimensions.clientWidth
    // let yRatio = pdfDimensions.height / positionOverlay.clientHeight
    // let xRatio = pdfDimensions.width / positionOverlay.clientWidth

    // Initialize variables for x and y positions
    let x = 0
    let y = 0

    // Determine if the mouse pointer is closer to the bottom or top of the position overlay
    let bottom = positionOverlay.clientHeight > offsetY + childElemHeight / 2
    let top = offsetY - childElemHeight / 2 > 0

    // Determine if the mouse pointer is closer to the right or left of the position overlay
    let right = positionOverlay.clientWidth > offsetX + childElemWidth / 2
    let left = offsetX - childElemWidth / 2 > 0

    // Calculate the y position of the signature image based on mouse pointer location
    if (!bottom && top) {
      // If closer to the top and not at the bottom, position near the bottom of the overlay
      y = positionOverlay.clientHeight - childElemHeight
    }
    if (bottom && !top) {
      // If closer to the bottom and not at the top, position at the top of the overlay
      y = 0
    }
    if (bottom && top) {
      // If both conditions meet, position at the mouse pointer's vertical midpoint
      y = offsetY - childElemHeight / 2
    }

    // Otherwise, position based on proximity to overlay edges
    if (!left && right) {
      // If closer to the right and not to the left, position at the left edge of the overlay
      x = 0
    }
    if (left && !right) {
      // If closer to the left and not to the right, position at the right edge of the overlay
      x = positionOverlay.clientWidth - childElemWidth
    }
    if (left && right) {
      // If both conditions meet, position at the mouse pointer's horizontal midpoint
      x = offsetX - childElemWidth / 2
    }

    // Set the left and top styles of the signature image element to position it on the overlay
    draggedElem.style.left = Math.floor(x) + "px"
    draggedElem.style.top = Math.floor(y) + "px"

    // Calculate the scaled coordinates for the signature position and update position
    let x1 = x * xRatio
    let y1 = Math.abs((positionOverlay.clientHeight - y - childElemHeight) * yRatio).toFixed(2)
    let x2 = (x + childElemWidth) * xRatio
    let y2 = (positionOverlay.clientHeight - y) * yRatio

    let currentCoordinate = `${x1}, ${y1}, ${x2}, ${y2}`

    console.log({ currentCoordinate })

    if (activePlacement && currentCoordinate) {
      let identifier = activePlacement.split("|")
      users = users.map((user) => {
        if (user.id == identifier[0]) {
          user.placements = user.placements.map((placement) => {
            if (placement.id == identifier[1]) {
              if (placement.coordinate !== currentCoordinate) {
                placement.coordinate = currentCoordinate
                currentCoordinate = ""
              }
            }
            return placement
          })
        }
        return user
      })
    }
  }

  const handleParentLeave = () => {
    enableDrag = false
    draggedElem = null
    console.log("parentLeave", activePlacement)
    // if (activePlacement && currentCoordinate) {
    //   let identifier = activePlacement.split("|")
    //   users = users.map((user) => {
    //     if (user.id == identifier[0]) {
    //       user.placements = user.placements.map((placement) => {
    //         if (placement.id == identifier[1]) {
    //           placement.coordinate = currentCoordinate
    //           currentCoordinate = ""
    //         }
    //         return placement
    //       })
    //     }
    //     return user
    //   })
    //   activePlacement = ""
    // }
  }
</script>

<div on:mousemove={positionOverlayMouseCapture} on:mouseup={handleParentLeave} on:mouseleave={handleParentLeave} class="relative flex h-full w-fit items-center {loadingPDF ? 'animate-pulse bg-gray-100/10' : ''}">
  <slot />
  {#each users as user (user.id)}
    {#each user.placements as placement (placement.id)}
      <Sign
        {pdfDimensions}
        {currentpage}
        {placement}
        signSource={user.sign}
        on:mousedown={(e) => {
          enableDrag = true
          draggedElem = e.target
          activePlacement = `${user.id}|${placement.id}`
        }}
        on:mouseup={(e) => {
          enableDrag = false
          // let isOverlapped = isOverlapping(e)
          // placement.error = isOverlapped
          // if (draggedElem) {
          //   if (currentCoordinate) {
          //     console.log("element leave", placement.id)
          //     placement.coordinate = currentCoordinate
          //     // placement.error = false
          //     currentCoordinate = ""
          //   }
          // }
          activePlacement = ""
          draggedElem = null
        }}
      />
    {/each}
  {/each}
</div>
